import React from "react";
import HomeCarousel from "../components/HomeCarousel";
import AboutSection from "../components/AboutSection";
import Services from "./Services";
import Feature from "./Feature";
import Projects from "./Projects";
import Team from "./Team";
import Contact from "./Contact";
import About from "./About";
import Testimonial from "./Testimonial";

const Home = () => {
  return (
    <div>
      <HomeCarousel />
      {/* <About/> */}
      <AboutSection/>
      <Services/>
      <Feature/>
      <Projects/>
      <Team/>
      <Testimonial/>
      <Contact/>
    </div>
  );
};

export default Home;